export default __webpack_public_path__ + "static/media/Contact icon - Light.75e95c70.svg";